var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolfJournalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.88889 0C1.12183 0 0.5 0.522335 0.5 1.16667V19.8333C0.5 20.4777 1.12183 21 1.88889 21H3.27778V0H1.88889ZM18.5556 0H3.97222V21H18.5556C19.3226 21 19.9444 20.4777 19.9444 19.8333V1.16667C19.9444 0.522334 19.3226 0 18.5556 0ZM22.7222 4.66667H25.5V15.1667H22.7222V4.66667ZM23.4167 2.91667C23.0331 2.91667 22.7222 3.17783 22.7222 3.5V4.08333H25.5V3.5C25.5 3.17783 25.1891 2.91667 24.8056 2.91667H23.4167ZM22.7222 15.75H25.5L24.4217 17.5616C24.2937 17.7766 23.9285 17.7766 23.8005 17.5616L22.7222 15.75ZM6.05556 2.33333C5.67202 2.33333 5.36111 2.5945 5.36111 2.91667V6.41667C5.36111 6.73883 5.67202 7 6.05555 7H17.8611C18.2446 7 18.5556 6.73883 18.5556 6.41667V2.91667C18.5556 2.5945 18.2446 2.33333 17.8611 2.33333H6.05556ZM7.44444 8.16667C7.06091 8.16667 6.75 8.42783 6.75 8.75C6.75 9.07217 7.06091 9.33333 7.44444 9.33333H16.4722C16.8558 9.33333 17.1667 9.07217 17.1667 8.75C17.1667 8.42783 16.8558 8.16667 16.4722 8.16667H7.44444ZM6.75 11.0833C6.75 10.7612 7.06091 10.5 7.44444 10.5H16.4722C16.8558 10.5 17.1667 10.7612 17.1667 11.0833C17.1667 11.4055 16.8558 11.6667 16.4722 11.6667H7.44444C7.06091 11.6667 6.75 11.4055 6.75 11.0833Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfJournalIcon);
export default __webpack_public_path__ + "static/media/golf-journal-icon.ca57139829f07dde67805aadb2724edd.svg";
export { ForwardRef as ReactComponent };